module.exports = __webpack_public_path__ + "static/media/contenzi.4699b90d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/contenzi.webp
// module id = 854
// module chunks = 0